import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { _cs } from '@togglecorp/fujs';
import { Link } from 'react-router-dom';
import { genericMemo, isValidUrl } from '../../utils/index.js';
import { useButtonFeatures } from '../Button/index.js';
import styles from './styles.css.js';

function ButtonLikeLink(props) {
  const {
    title,
    variant,
    className: classNameFromProps,
    actionsContainerClassName,
    iconsContainerClassName,
    childrenContainerClassName,
    disabled,
    children: childrenFromProps,
    icons,
    actions,
    big,
    to,
    ...linkProps
  } = props;
  const {
    className,
    children
  } = useButtonFeatures({
    variant,
    className: classNameFromProps,
    actionsContainerClassName,
    iconsContainerClassName,
    childrenContainerClassName,
    disabled,
    children: childrenFromProps,
    icons,
    actions,
    big
  }); // FIXME: the typing is problematic

  const isExternalLink = React.useMemo(() => typeof to === 'string' && isValidUrl(to), [to]);

  if (!to) {
    return null;
  }

  if (isExternalLink) {
    return /*#__PURE__*/React.createElement("a", _extends({
      href: to,
      className: _cs(className, styles.link),
      target: "_blank",
      rel: "noopener noreferrer",
      title: title
    }, linkProps), children);
  }

  return /*#__PURE__*/React.createElement(Link, _extends({
    className: _cs(className, styles.link),
    title: title,
    to: to
  }, linkProps), children);
}

var ButtonLikeLink$1 = genericMemo(ButtonLikeLink);

export { ButtonLikeLink$1 as default };
//# sourceMappingURL=index.js.map
